import gql from "graphql-tag";

const READ_NOTIFICATION = gql`
  mutation read($id: ID!) {
    readNotification(where: { id: $id })
  }
`;

export default READ_NOTIFICATION;
